import gql from "graphql-tag";
import { preJobCheckListV2Field } from "./getJob";

/**
 * VEHICLE-HISTORY (NUB-358): every job for the customer, in one request.
 *
 * Not filtered to the vehicle server-side: older jobs have no `vehicleId` to filter on, so they are matched by VIN
 * or plate here. `invoice` is DataLoader-batched.
 * Read with no-cache: it would otherwise write every job, the open one included, into the cache the job page reads.
 */
export const GET_VEHICLE_JOB_HISTORY = gql`
  query getVehicleJobHistory($filter: JSON, $limit: Int) {
    getJobs(filter: $filter, limit: $limit) {
      edges {
        id
        jobNumber
        type
        # What was quoted, to tell an inspected item that was quoted but not invoiced.
        services {
          id
          name
        }
        status
        createdAt
        vehicleId
        vehicleInfo {
          year
          make
          model
          vin
          licensePlate
          licensePlateState
          odometer
        }
        appointment {
          id
          startDate
          endDate
          technician {
            id
            firstName
            lastName
          }
        }
        ${preJobCheckListV2Field}
        invoice {
          id
          issuedDate
          status
          services {
            id
            name
            items {
              id
              category
              units
              productSelection {
                name
              }
              orderItem {
                partNumber
                partsStore {
                  id
                  name
                  vendor
                }
              }
              jobItem {
                partNumber
                partOrder {
                  id
                  store {
                    id
                    name
                    vendor
                  }
                }
              }
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        numRecords
      }
    }
  }
`;
